module.exports = __webpack_public_path__ + "img/empty.903b8eb2.png";